
import * as React from "react"
import * as ReactDOM from "react-dom"
import { FormattedNumber, IntlProvider, addLocaleData } from "react-intl"
import { RentalAdvertPricing } from '../../../types/types'
import PricingError from '../../../components/PricingError'

type Props = {
  pricing: RentalAdvertPricing
  close: () => void
}

type State = {
}

declare var window: { Gites: { locale: string }};
declare var $: any

export default class Error extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
    this.state = {
    }
  }

  render() {
    return (
      <IntlProvider locale={window.Gites.locale}>
        <PricingError
          error={this.props.pricing.error}
          close={() => this.props.close()}
        />

      </IntlProvider>
    )
  }
}
